<template>
  <div class="card">
    <div class="row pb-2">
      <div class="form-group col col-md-6 required">
        <div class="form-item">
          <component-input
            label="Тема сообщения"
            v-model="card.topic"
            required
          />
        </div>
        <div class="form-item">
          <component-input
            label="Адрес электронной почты"
            v-model="card.email"
            placeholder="name@example.ru"
            required
          />
          <div class="invalid-msg" v-if="v$.card.email.$error">
              Поле содержит некорректное значение
          </div>
        </div>
        <div class="form-item">
          <component-input
            label="Номер телефона для связи"
            v-model="card.phone"
            type="phone"
            required
          />        
        </div>
        <div class="form-item">
          <component-input
            v-model="card.question"
            type="textarea"
            label="Описание вопроса"
            required
          />  
        </div>
      </div>
      <div class="form-group col col-md-6 required">
        <label class="control-label">Файлы</label>
        <file-multi-upload
          :entity="card"
          prop-name="files"
          @uploaded="fileUploaded"
          @deleteFile="removeFile"
        />
      </div>
    </div>   
    <div class="card-footer">
      <div class="d-flex align-items-center float-right">
        <button-component class="btn btn-primary mx-2" v-on:click="send">Отправить
        </button-component>
        <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="cancel">Сбросить
        </button-component>
      </div>
    </div>

    <template v-if="page.items?.length">
      <p>Ранее отправленные запросы</p>
      <div class="table-inner">
        <table class="table-custom">
          <thead>
          <tr>            
            <th>Дата и время отправки</th>
            <th>Тема</th>            
          </tr>
          </thead>
          <tbody>
          <tr class="clickable-area" v-for="item in page.items" :key="item.id" @click="viewCard(item)">
            <td>{{ item.sendDate ? $momentFormat(item.sendDate, 'DD.MM.YYYY HH:mm') : '' }}</td>
            <td>{{ item.topic }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination :page-count="page.pagesTotal" :current-page="page.pageNumber" @change="onPageChange($event)"/>
      </div>
      <div>
        <PageCounter :isFiltered="false" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
      </div>
    </template>
    <modal-component v-if="modalCard" title="Данные запроса"
                    @close="modalCard = null">
        <div class="row pb-2">          
          <div class="form-group col col-md-4">            
            <label class="control-label">Дата отправки</label>
          </div>
          <div class="form-group col col-md-8">            
            <p>{{modalCard?.sendDate ? $momentFormat(modalCard.sendDate, 'DD.MM.YYYY HH:mm') : ''}}</p>
          </div>
        </div>
        <div class="row pb-2">          
          <div class="form-group col col-md-4">            
            <label class="control-label">Тема сообщения</label>
          </div>
          <div class="form-group col col-md-8">            
            <p>{{modalCard?.topic}}</p>
          </div>
        </div>
        <div class="row pb-2">          
          <div class="form-group col col-md-4">            
            <label class="control-label">Описание вопроса</label>
          </div>
          <div class="form-group col col-md-8">            
            <p>{{modalCard?.question}}</p>
          </div>
        </div>
        <div class="row pb-2" v-if="modalCard?.files && modalCard?.files?.length">          
          <label class="control-label">Файлы</label>
          <file-multi-upload
            :entity="modalCard"
            prop-name="files"
            :readonly="true"
          />
        </div>
        <div class="d-flex align-items-center float-right">
          <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="modalCard = null">Закрыть
          </button-component>
      </div>
    </modal-component>
  </div>
</template>
<script>
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import FileMultiUpload from "@/common/components/FileMultiUpload";
import disableAll from "@/common/directives/disable-all";
import Constants from "@/common/constants";
import {useVuelidate} from '@vuelidate/core';
import API from '../api/techSupport';
import User_API from "@/modules/admin/api/users";
import { email, required } from '@vuelidate/validators'
import ModalComponent from "@/common/ui/ModalComponent";
import PageCounter from "@/common/components/PageCounter";

export default {
  name: "TechSupportCard",
  components: {
    ButtonComponent, ComponentInput, FileMultiUpload, ModalComponent, PageCounter
  },
  directives: {
    'disable-all': disableAll
  },
  created() {    
    const self = this;
    API.search({ pageNumber: 1, pageSize: 1 }).then(function (response) {      
      self.totalCount = response.data.itemsTotal;
    });
    this.loadProfile();
    this.loadPage();
  },
  data() {
    return {
      request: {
        pageNumber: 1,
        pageSize: Constants.pageSize
      },
      card: {
        files: []
      },
      modalCard: null,
      page: {},
      user: null,
      totalCount: 0
    };
  },
  methods: {
    loadProfile() {
      let sub = this.$store.state?.auth?.oidc?.user?.profile?.sub;
      if (sub) 
        User_API.find(sub).then(response => {
          this.user = response.data;
          if (this.user) {
            this.card.email = this.user.email;
            this.card.phone = this.user.phoneNumber;          
          }
        });
    },   
    loadPage() {
      API.search(this.request).then((response) => {
        this.page = response.data;        
      });
    },  
    cancel() {
      this.v$.$reset();
      this.card = {
        files: [],
        email: this.user?.email,
        phone: this.user?.phoneNumber
      };
    }, 
    send() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }      

      API.send(this.card).then((response) => {
        const msg = 'Вопрос успешно отправлен.'
        Constants.alert.fire('Отправка запроса', response.data.success ? msg : response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          this.cancel();
          this.loadPage();
        }
      }).catch(() => {
        Constants.alert.fire('Отправка запроса', "Не удалось отправить запрос. Попробуйте позже", 'error');
      });
    },    
    fileUploaded(e) {
      this.card.files.push(e.data);
    },
    removeFile(e) {
      const file = this.card.files.find(x => x.id === e.id);
      const index = this.card.files.indexOf(file);
      if (index > -1) {
        this.card.files.splice(index, 1);
      }
    },
    viewCard(item) {
      this.modalCard = item;
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      card: {
        email: { email, required }
      }
    }
  }
}
</script>
<style lang="scss">
  .tox-statusbar__branding,
  .tox-notification.tox-notification--in.tox-notification--warning{
    display: none;
  }
</style>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.card::v-deep {
  padding: 24px;
  margin: 16px 24px 0 24px;
  border-radius: 12px;
  border: none;
  box-shadow: none;
  background-color: #fff;
  .modal-dialog {
    display: flex;
    align-items: center;
  }
}

.form-item {
  margin-bottom: 14px;
}

.clickable-area {
  cursor: pointer;
}
</style>
